export const DELIVERY_STATUS_LIST = [
  { value: '1', label: 'CT To Confirm' },
  { value: '2', label: 'Confirmed' },
  { value: '5', label: 'Trip Started' },
  { value: '6', label: 'In Transit For Load' },
  { value: '7', label: 'At Loading Location' },
  { value: '8', label: 'Goods Loaded' },
  { value: '9', label: 'In Transit For Delivery' },
];
